import _ from '@lodash';
import * as yup from 'yup';
import { useEffect, useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { generateId } from 'app/admin/whatIf/component/WhatIfUtil';
import { useWorkflow } from '../../WorkflowProvider';
import BlenderConversion from './BlenderConversion';
import BlenderProvider, { useBlender } from './BlenderProvider';
import { TransComponentTitleField, TransFeatureColumnField, TransInputKeyField, TransNameField, TransOutputKeyField, TransValidationIOKey, TransValidationName } from '../TransformationProperties';
import TransformationPropertiesDialog from '../TransformationPropertiesDialog';
import { converter } from './BlenderTransformation';

function BlenderProperties() {
	const { data, showPropertiesDialog, transformationNameAvailable } = useWorkflow();
	const { t } = useTranslation(['transformer', 'validation']);
	const item = data.transform.find(d => d.key === showPropertiesDialog.key);
	const [tabValue, setTabValue] = useState(0);
	const { grid, setGrid, getClipboard, clipboard, toClipboard } = useBlender();

	useEffect(() => {
		if (item)
			setGrid({ rows: item.rows, columns: item.columns, conversion: item.conversion });
	}, [item]);

	useEffect(() => {
		if (clipboard) {
			let rows = []; let columns = []; let conversion = [];

			const getColumnId = (name) => { for (let i = 0; i < rows.length; i += 1) if (rows[i].name === name) return rows[i].key; return null; };
			const getRowId = (name) => { for (let i = 0; i < columns.length; i += 1) if (columns[i].name === name) return columns[i].key; return null; };

			for (let key in clipboard) rows.push({ key: generateId(), name: key });
			for (let key in clipboard[Object.keys(clipboard)[0]]) columns.push({ key: generateId(), name: key });

			for (let key in clipboard)
				for (let _key in clipboard[key])
					conversion.push({ key: generateId(), row: getColumnId(key), column: getRowId(_key), value: clipboard[key][_key] });

			setGrid({ rows, columns, conversion });
		}
	}, [clipboard]);

	const schema = yup.object().shape({
		name: TransValidationName(transformationNameAvailable, item.key),
		input_fields: TransValidationIOKey(),
		output_fields: TransValidationIOKey()
	});

	const handleTabChange = (event, value) => {
		setTabValue(value);
	};

	return (
		<TransformationPropertiesDialog
			maxWidth="lg"
			schema={schema}
			titleKey="blenderProperties"
			converter={converter}
			enableCopyPase
			onCopyJson={() => toClipboard('JSON')}
			onCopyXls={() => toClipboard('XLS')}
			onPaste={() => getClipboard()}
			titleContent={<Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" classes={{ root: 'h-64 bg-white' }}>
				<Tab className="h-64" label={t('basicInfo')} />
				<Tab className="h-64" label={t('conversion')} />í
			</Tabs>}
			mergeValue={value => { return { ...value, ...grid }; }}
			mergeProcess={(value, def) => { const result = { ...value, ...def }; result.conversion = value.conversion; return result; }}>

			<div className={tabValue !== 0 ? 'hidden' : ''}>

				<TransNameField />

				<TransInputKeyField clipboard={clipboard} />

				<TransOutputKeyField />
				<TransFeatureColumnField />
				<TransComponentTitleField />

			</div>

			<div className={tabValue !== 1 ? 'hidden' : ''}>{tabValue === 1 && <BlenderConversion clipboard={clipboard} />}</div>

		</TransformationPropertiesDialog>
	);
}


export default function () {
	return (<BlenderProvider><BlenderProperties /></BlenderProvider>);
}